import {
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CFormInput,
  CRow,
  CTableHeaderCell,
  CTableRow,
  CFormLabel,
  CTableDataCell,
} from '@coreui/react-pro'
import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import ToastComponent from 'src/components/common/TaostComponent'
import Loader from 'src/components/Loader'
import moment from 'moment'
import CommonService from 'src/service/CommonService'

const BrandingAnalytics = () => {
  const [result, setResult] = useState()
  const [totalCount, setTotalCount] = useState(0)
  const [loader, setLoader] = useState(true)
  const param = useParams()
  useEffect(() => {
    CommonService.getBrandingViews('branding')
      .then((res) => {
        if (res.status === 200) {
          setLoader(false)
          setResult(res.data)
          setTotalCount(res.totalCountBranding)
        }
      })
      .catch((e) => {
        ToastComponent('Something went wrong. Please try again.', 'error')
        setLoader(false)
      })
  }, [param.type])
  return (
    <>
      <CRow>
        <CCol xs={12}>
          <CCard className="mb-4">
            <CCardHeader>
              <strong>
                {' '}
                <Link to="/branding">Branding Log</Link>{' '}
              </strong>
            </CCardHeader>
            <CCardBody>
              {loader ? (
                <Loader />
              ) : (
                <div className="table-responsive">
                  <table className="main-table table innertable">
                    <tbody>
                      <tr>
                        <th>Name</th>
                        <td>{result.branding?.name}</td>
                      </tr>
                      <tr>
                        <th>Brand Views</th>
                        <td>{result.branding?.click_count}</td>
                      </tr>
                      <tr>
                        <th>Website</th>
                        <td>{result.branding_website?.click_count}</td>
                      </tr>
                      <tr>
                        <th>Facebook</th>
                        <td>{result.facebook_count?.click_count}</td>
                      </tr>
                      <tr>
                        <th>Twitter</th>
                        <td>{result.twitter_count?.click_count}</td>
                      </tr>
                      <tr>
                        <th>Instagram</th>
                        <td>{result.instagram_count?.click_count}</td>
                      </tr>
                      <tr>
                        <th>Total</th>
                        <CTableDataCell>{totalCount}</CTableDataCell>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </>
  )
}

export default BrandingAnalytics
